export class FeatureFlags {
    constructor(contentService) {
        this.contentService = contentService;
    }
    isEnabled(featureDcr) {
        return this.contentService.get(featureDcr, 'DISABLED').toLowerCase() === 'enabled';
    }
}
